import type { AssessmentState, CompanyProfile, LeadPayload } from './types'

export function isNonEmpty(value: unknown): boolean {
  if (value == null) return false
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'string') return value.trim().length > 0
  return true
}

export function validateCompanyProfile(profile: CompanyProfile): string[] {
  const errors: string[] = []
  if (!profile.sector) errors.push('Select a company sector.')
  if (!profile.emirate) errors.push('Select an emirate of operations.')
  if (!profile.companySize) errors.push('Select company size.')
  if (!profile.businessActivities?.length) errors.push('Select at least one business activity.')
  if (!profile.operatingFootprint) errors.push('Select operating footprint.')
  if (!profile.listingStatus) errors.push('Select listing status.')
  return errors
}

export function validateEmail(email: string): boolean {
  const trimmed = email.trim()
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)
}

export function validateLeadPayload(payload: Partial<LeadPayload>): string[] {
  const errors: string[] = []
  if (!payload.workEmail || !validateEmail(payload.workEmail)) {
    errors.push('A valid work email is required.')
  }
  if (!payload.companyName || !payload.companyName.trim()) {
    errors.push('Company name is required.')
  }
  if (!payload.fullName || !payload.fullName.trim()) {
    errors.push('Name is required.')
  }
  if (!payload.consentReport) {
    errors.push('Consent to process your details for the report is required.')
  }
  return errors
}

export function countNotSure(state: AssessmentState): number {
  let count = 0
  for (const value of Object.values(state.responses)) {
    if (value === 'not_sure' || (Array.isArray(value) && value.includes('not_sure'))) count += 1
  }
  for (const rating of Object.values(state.materiality)) {
    if (rating.financial === 'not_sure') count += 1
    if (rating.impact === 'not_sure') count += 1
  }
  for (const carbon of Object.values(state.carbon)) {
    if (
      carbon.exists === 'not_sure' ||
      carbon.dataCollected === 'not_sure' ||
      carbon.evidenceAvailable === 'not_sure' ||
      carbon.ownerAssigned === 'not_sure' ||
      carbon.methodDocumented === 'not_sure' ||
      carbon.readiness === 'not_sure'
    ) {
      count += 1
    }
  }
  return count
}
